function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { __decorate } from '../../node_modules/tslib/tslib.es6.js';
import { property, target, registerElement, ImpulseElement } from '@ambiki/impulse';
import '../../node_modules/@oddbird/popover-polyfill/dist/popover.js';
import { isLooselyFocusable } from '../../helpers/focus.js';
import useFloatingUI from '../../hooks/use_floating_ui.js';
import useOutsideClick from '../../hooks/use_outside_click.js';
import { stripCSSUnit } from '../../helpers/string.js';
var popovers = new Set();

var AwcPopoverElement = /*#__PURE__*/function (_ImpulseElement) {
  _inherits(AwcPopoverElement, _ImpulseElement);

  var _super = _createSuper(AwcPopoverElement);

  function AwcPopoverElement() {
    var _this;

    _classCallCheck(this, AwcPopoverElement);

    _this = _super.apply(this, arguments);
    /**
     * The placement of the popover. The actual placement will vary to keep the popover inside the viewport.
     * @see https://floating-ui.com/docs/computePosition#placement for a comprehensive list of all available placements.
     */

    _this.placement = 'bottom';
    /**
     * The value of the `position` CSS property.
     * @see https://floating-ui.com/docs/computePosition#strategy
     */

    _this.strategy = 'fixed';
    /**
     * The CSS selector of the element that should avoid closing the popover when clicked inside.
     */

    _this.clickBoundaries = [];
    return _this;
  }

  _createClass(AwcPopoverElement, [{
    key: "connected",
    value: function connected() {
      var _this2 = this;

      this.floatingUI = useFloatingUI(this, {
        referenceElement: this.button,
        popupElement: this.panel,
        arrowElement: this.arrow,
        arrowPadding: this.arrowPadding,
        placement: this.placement,
        strategy: this.strategy,
        offsetOptions: 8,
        flipOptions: {
          fallbackAxisSideDirection: 'end'
        }
      });
      useOutsideClick(this, {
        boundaries: this.boundaries,
        callback: function callback(event, target) {
          // Only proceed if element is open and nested popovers are hidden.
          if (_this2.open && !_this2.hasNestedOpenPopovers) {
            _this2.hide(); // Prevent modals from closing accidentally.


            if (!isLooselyFocusable(target)) {
              event.preventDefault();

              _this2.button.focus();
            }
          }
        }
      });
    }
  }, {
    key: "disconnected",
    value: function disconnected() {
      this.hide();
    }
  }, {
    key: "handleToggle",
    value: function () {
      var _handleToggle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.open) {
                  _context.next = 9;
                  break;
                }

                popovers.add(this);
                this.closeOtherPopovers();
                this.emit('show');
                this.button.setAttribute('aria-expanded', 'true');
                this.floatingUI.start();
                this.emit('shown');
                _context.next = 15;
                break;

              case 9:
                this.emit('hide');
                this.button.setAttribute('aria-expanded', 'false');
                _context.next = 13;
                return this.floatingUI.stop();

              case 13:
                popovers.delete(this);
                this.emit('hidden');

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleToggle() {
        return _handleToggle.apply(this, arguments);
      }

      return handleToggle;
    }()
  }, {
    key: "toggle",
    value: function toggle() {
      this.panel.togglePopover();
    }
  }, {
    key: "show",
    value: function show() {
      if (this.open) return;
      this.panel.showPopover();
    }
  }, {
    key: "hide",
    value: function hide(event) {
      if (!this.open) return;
      this.panel.hidePopover(); // This event originated from a button click.

      if (event) {
        this.button.focus();
      }
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      switch (event.key) {
        case 'Escape':
          {
            var _target = event.target;

            var popover = _target.closest(this.identifier);

            if (popover !== this && (popover === null || popover === void 0 ? void 0 : popover.open)) return;

            if (this.open) {
              // prevent modals from accidentally closing.
              event.preventDefault();
              event.stopPropagation();
              this.hide();
              this.button.focus();
            }

            break;
          }
      }
    }
  }, {
    key: "reposition",
    value: function () {
      var _reposition = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.floatingUI.update();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function reposition() {
        return _reposition.apply(this, arguments);
      }

      return reposition;
    }()
  }, {
    key: "closeOtherPopovers",
    value: function closeOtherPopovers() {
      var _iterator = _createForOfIteratorHelper(popovers),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var popover = _step.value;
          if (popover === this || popover.contains(this)) continue;
          popover.hide();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "hasNestedOpenPopovers",
    get: function get() {
      var _this3 = this;

      var popover = _toConsumableArray(popovers).find(function (p) {
        return p === _this3;
      });

      if (!popover) return false;
      var childPopovers = Array.from(popover.querySelectorAll(this.identifier));
      return childPopovers.some(function (childPopover) {
        return popovers.has(childPopover);
      });
    }
  }, {
    key: "arrowPadding",
    get: function get() {
      var borderRadius = getComputedStyle(this.panel).borderRadius;
      return stripCSSUnit(borderRadius) || 2;
    }
  }, {
    key: "boundaries",
    get: function get() {
      var elements = this.clickBoundaries.map(function (s) {
        return document.querySelector(s);
      });
      return elements.concat([this.button, this.panel]);
    }
  }, {
    key: "open",
    get: function get() {
      if (!this.panel) return false;

      try {
        return this.panel.matches(':popover-open');
      } catch (_a) {
        return this.panel.matches('.\\:popover-open');
      }
    }
  }]);

  return AwcPopoverElement;
}(ImpulseElement);

__decorate([property()], AwcPopoverElement.prototype, "placement", void 0);

__decorate([property()], AwcPopoverElement.prototype, "strategy", void 0);

__decorate([property({
  type: Array
})], AwcPopoverElement.prototype, "clickBoundaries", void 0);

__decorate([target()], AwcPopoverElement.prototype, "button", void 0);

__decorate([target()], AwcPopoverElement.prototype, "panel", void 0);

__decorate([target()], AwcPopoverElement.prototype, "arrow", void 0);

AwcPopoverElement = __decorate([registerElement('awc-popover')], AwcPopoverElement);
var AwcPopoverElement$1 = AwcPopoverElement;
export { AwcPopoverElement$1 as default };